export default "<ontology-table *ngIf=\"dataMapping && dataMapping.queryDataMappings.length > 0\" [dataMapping]=\"dataMapping\"></ontology-table>\n"